import { RODO_DOCUMENT, CHILD_PROTECT_DOCUMENT } from '@/config/requiredDocumentsCodes.ts'

export class DocumentToAcceptError {
    documentToAccept: typeof RODO_DOCUMENT | typeof CHILD_PROTECT_DOCUMENT
    message: string

    constructor(
        documentToAccept: typeof RODO_DOCUMENT | typeof CHILD_PROTECT_DOCUMENT,
        message: string,
    ) {
        this.documentToAccept = documentToAccept
        this.message = message
    }
}
